const data = require('@/assets/data/data.json');

const state = {
  data: {},
  value: 0,
  highlightIndex: 0,
  chart: []
};

const mutations = {
  setHighlight(state, idHighlight) {
    state.highlightIndex = idHighlight;
  },
  setIncome(state, income) {
    const formatedIncome = parseFloat((income / 100).toFixed(2));
    const dataIChart = data;

    let mostClose = dataIChart.filter((item) => {
      return (formatedIncome <= item.monthly_income) ? true : false ;
    })[0] || dataIChart[ dataIChart.length -1 ];

    console.log(mostClose);

    const indexMostClose = data.findIndex((item) => {
      return (item.monthly_income == mostClose.monthly_income) ? true : false ;
    });

    mostClose.highlight = true;

    state.data = mostClose;

    const total = data.length;

    let list = [];

    for(let i = 0; i < total; i++) {
      if (i == indexMostClose) {
        list.push(mostClose);
      } else {
        list.push(data[i]);
      }
    }
    
    state.chart = list;
    state.value = formatedIncome;
    state.highlightIndex = indexMostClose;
  },
};

const actions = {
  setIncome({ commit }, income) {
    commit('setIncome', income);
  },
  setHighlight({ commit }, idHighlight) {
    commit('setHighlight', idHighlight);
  }
};

export default {
  namespaced: true,
  actions,
  mutations,
  state,
};
